"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const form_context_1 = require("./form-context");
const AkForm = require("@atlaskit/form").default;
class Form extends React.Component {
    render() {
        const { onSubmit, className, children } = this.props;
        return (React.createElement(AkForm, { onSubmit: onSubmit, className: className }, ({ formProps, dirty, submitting, getValues }) => (React.createElement("form", Object.assign({}, formProps, { className: className, onSubmit: event => {
                event.stopPropagation();
                return formProps.onSubmit(event);
            } }),
            React.createElement(form_context_1.FormContext.Provider, { value: {
                    isDirty: dirty,
                    isSubmitting: submitting,
                    getValues
                } }, children)))));
    }
}
exports.Form = Form;
